// @flow
import {
  RadioSelect,
  Slider,
  NumberInput,
  SimpleCollapse,
  UniversalPaginationButton,
  ListToggle,
  Typeahead,
  FulltextAutocomplete,
  PasswordToggle,
  // SocialShare,
  AnchorsList,
  RadioSelectTab,
  GreedyMenu,
} from 'fg-frontend';


import Webslider from './components/Webslider';
import SelectDesign from './components/SelectDesign';
import Webmap from './components/Webmap';
import configureEshopComponents from './configureEshopComponents';

export default (props) => {
  switch (props.decorator || props.is) {
    case 'RadioSelect':
    case 'CheckboxSelect':
      return RadioSelect;
    case 'SimpleCollapse':
      return SimpleCollapse;
    case 'GreedyMenu':
      return GreedyMenu;
    case 'Typeahead':
      return Typeahead;
    case 'SelectDesign':
      return SelectDesign;
    case 'ListToggle':
      return ListToggle;
    case 'PasswordToggle':
      return PasswordToggle;
      // case 'SocialShare':
      // 	return SocialShare;
    case 'Webslider':
      return Webslider;
    case 'AnchorsList':
      return AnchorsList;
    case 'FulltextAutocomplete':
      return FulltextAutocomplete;
    case 'Slider':
      return Slider;
    case 'RadioSelectTab':
      return RadioSelectTab;
    case 'NumberInput':
      return NumberInput;
    case 'UniversalPaginationButton':
      return UniversalPaginationButton;
    case 'Webmap':
      return Webmap;
    default:
      const eshopComponent = configureEshopComponents(props);
      if (eshopComponent) {
        return eshopComponent;
      }

      console.log(`Unknown component ${props.decorator || props.is}`);
      return null;
  }
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/configureWebComponents.js